var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 711.45 537.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4,.cls-5,.cls-8{fill:none;}.cls-1,.cls-2,.cls-5{stroke:#d1ebf6;}.cls-1,.cls-12,.cls-2,.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:9.61px;}.cls-2{stroke-width:6.47px;}.cls-13,.cls-3,.cls-9{opacity:0.36;}.cls-4{stroke:#b6b6b5;stroke-width:6.41px;}.cls-5,.cls-8{stroke-width:6.86px;}.cls-6{fill:#d1ebf6;}.cls-7{fill:#a4d3e2;}.cls-8{stroke:#a4d3e2;}.cls-10,.cls-11,.cls-8{stroke-miterlimit:10;}.cls-9{fill:#bdbec0;}.cls-10{fill:#ddf0f7;stroke-width:2.29px;}.cls-10,.cls-11,.cls-12{stroke:#808386;}.cls-11{fill:#f1f9fe;}.cls-11,.cls-12{stroke-width:2.29px;}.cls-12{fill:#fff;}.cls-13{fill:#b6b6b5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404 final ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.91,
    y1: 81.26,
    x2: 90.91,
    y2: 97.93
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.91,
    y1: 133.88,
    x2: 90.91,
    y2: 150.55
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.56,
    y1: 115.9,
    x2: 108.89,
    y2: 115.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.94,
    y1: 115.9,
    x2: 56.26,
    y2: 115.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 605.21,
    y1: 231.86,
    x2: 605.21,
    y2: 239.73
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 605.21,
    y1: 256.68,
    x2: 605.21,
    y2: 264.54
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 621.55,
    y1: 248.2,
    x2: 613.69,
    y2: 248.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 596.73,
    y1: 248.2,
    x2: 588.87,
    y2: 248.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 531.23,
    y1: 212.44,
    x2: 524.62,
    y2: 219.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 510.36,
    y1: 233.31,
    x2: 503.75,
    y2: 239.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 531.23,
    y1: 239.92,
    x2: 524.62,
    y2: 233.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 510.36,
    y1: 219.06,
    x2: 503.75,
    y2: 212.44
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 38.45,
    cy: 336,
    r: 17.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 116.87,
    cy: 199.82,
    r: 7.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 524.21,
    cy: 422.45,
    r: 8.56
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 527.2,
    cy: 66.35,
    r: 16.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M538.88,134.17a19.15,19.15,0,0,1-19.15,19.17H408.35a16.19,16.19,0,0,1-6.77,30.91H381.33a18.24,18.24,0,0,1,5,29.37,18,18,0,0,1-5.72,3.87h46.13a16.21,16.21,0,1,1,0,32.42H251.61a16.22,16.22,0,0,1-11.46-27.68,15.68,15.68,0,0,1,4.71-3.25H202.42a18.27,18.27,0,1,1,0-36.54H219a16.2,16.2,0,0,1,.67-29.1H165.4a19.16,19.16,0,1,1,0-38.32H277a16.21,16.21,0,0,0-2.18-27.3H227.47a17.22,17.22,0,1,1,0-34.43H458.05a17.22,17.22,0,1,1,0,34.43H415.83a16.54,16.54,0,0,0-3.91,2.88A16.23,16.23,0,0,0,413.66,115H519.73A19.16,19.16,0,0,1,538.88,134.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M588.23,306.83v1.26a15.67,15.67,0,0,1-15.68,15.67H523.82a15.74,15.74,0,0,0-3.41,2.59,16.15,16.15,0,0,0,2.82,25.14h32.49a17.71,17.71,0,0,1,0,35.42H383.6a17.71,17.71,0,0,1-12.54-30.22,17.5,17.5,0,0,1,3.43-2.68h-5.44a16.2,16.2,0,1,1,0-32.4h35.23a15.54,15.54,0,0,1-7.8-13.52v-1.26a15.66,15.66,0,0,1,15.67-15.67h160.4A15.67,15.67,0,0,1,588.23,306.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.56,428.43a17.75,17.75,0,0,0,2.81,27.34h53a17.7,17.7,0,1,1,0,35.4H186.24a17.7,17.7,0,0,1,0-35.4h19.29a16.87,16.87,0,0,0,2.81-2.28,17.69,17.69,0,0,0-3-27.44H56.86a17.71,17.71,0,0,1,0-35.41H180.07a17.56,17.56,0,0,0,7.36-14.37,17.69,17.69,0,0,0-16.2-17.64H122.64a17.7,17.7,0,1,1,0-35.39h6c6-2.41,10.2-8.65,10.2-16v-1.35c0-7.64-4.62-14.1-10.95-16.27H77.8A15.68,15.68,0,0,1,62.13,274V272.7A15.68,15.68,0,0,1,77.8,257H238.2a15.68,15.68,0,0,1,15.67,15.67V274a15.68,15.68,0,0,1-15.67,15.67H210.91c-6.34,2.17-11,8.63-11,16.27v1.35c0,7.32,4.23,13.56,10.2,16h84.61a17.69,17.69,0,0,1,1.51,35.32h42a17.72,17.72,0,0,1,12.54,30.23,17.52,17.52,0,0,1-2.2,1.85h22.54a17.71,17.71,0,0,1,0,35.41H305.56A17.06,17.06,0,0,0,302.56,428.43Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 617.17,
    y: 288.71,
    width: 76.93,
    height: 30.99,
    rx: 15.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 562.26,
    y: 115.01,
    width: 55.72,
    height: 35.34,
    rx: 17.67
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 432.87,
    y: 427.2,
    width: 51.1,
    height: 30.72,
    rx: 15.36
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 233.32,
    y: 108.18,
    width: 207.13,
    height: 276.73,
    rx: 13.04,
    transform: "translate(40.76 -47.71) rotate(8.62)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 237.39,
    y: 113.89,
    width: 207.13,
    height: 276.73,
    rx: 13.04,
    transform: "translate(-36.09 58.04) rotate(-9.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M439.94,167.47V379A13,13,0,0,1,426.89,392H244.22A13.05,13.05,0,0,1,231.17,379V126.15a13.06,13.06,0,0,1,13.05-13.05h141.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M387.2,160.78V113.1l53.55,53.55-47.51.15A6,6,0,0,1,387.2,160.78Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 266.51,
    y: 194.65,
    width: 43.49,
    height: 43.49,
    rx: 8.15
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 334.47,
    y: 195.74,
    width: 60.89,
    height: 9.24,
    rx: 4.62
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 334.47,
    y: 238.96,
    width: 60.89,
    height: 9.24,
    rx: 4.62
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 263.52,
    y: 283,
    width: 131.84,
    height: 9.24,
    rx: 4.62
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 263.52,
    y: 326.76,
    width: 131.84,
    height: 9.24,
    rx: 4.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3830faee7d34a0ea8888574d0990f2ac.svg";
export { ForwardRef as ReactComponent };